import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-tools-chemicals',
    templateUrl: './icon-tools-chemicals.component.html'
})
export class IconToolsChemicalsComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit(): void {
    }

}
